import { call, put, takeLatest } from 'redux-saga/effects';
import { request } from 'utils/request';
import { IRestApiResponse } from 'interfaces';
import { ITenantFetchAction } from './interface';
import { CoreSliceActions } from './slice';
import API from './constants';

export function* tenantFetchGenerator({ payload }: ITenantFetchAction) {
  try {
    const response: IRestApiResponse = yield call(
      request,
      { path: `${API.GET_FETCH_TENANT.path}/${payload.slug}`, method: API.GET_FETCH_TENANT.method },
      null,
      true,
    );
    if (response.statusCode === 200) {
      if (response.data !== null && response.data !== '') {
        yield put(CoreSliceActions.fetchTenantSucceeded(response.data));
        yield payload.resolve();
      } else {
        yield put(CoreSliceActions.fetchTenantFailed('Tenant not found'));
        yield payload.reject();
      }
    } else {
      yield put(CoreSliceActions.fetchTenantFailed('Tenant request failed'));
      yield payload.reject();
    }
  } catch (err) {
    yield put(CoreSliceActions.fetchTenantFailed('Tenant request failed'));
    yield payload.reject();
  }
}

export function* getNotificationsGenerator() {
  try {
    const response: IRestApiResponse = yield call(
      request,
      { path: `${API.GET_USER_NOTIFICATIONS.path}?isExpert=true`, method: API.GET_USER_NOTIFICATIONS.method },
      null,
      true,
    );
    if (response.statusCode === 200) {
      if (response.data !== null && response.data !== '') {
        yield put(CoreSliceActions.setNotifications(response.data));
      }
    }
  } catch (error) {
    console.error(error);
  }
}

export function* coreSaga() {
  yield takeLatest(CoreSliceActions.fetchTenant.type, tenantFetchGenerator);
  yield takeLatest(CoreSliceActions.getNotifications.type, getNotificationsGenerator);
}
export default coreSaga;
